/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Backbutton1Inputs */

const en_privacy_backbutton1 = /** @type {(inputs: Privacy_Backbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Back`)
};

const fr_privacy_backbutton1 = /** @type {(inputs: Privacy_Backbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Retour`)
};

/**
* | output |
* | --- |
* | "← Back" |
*
* @param {Privacy_Backbutton1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const privacy_backbutton1 = /** @type {((inputs?: Privacy_Backbutton1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Backbutton1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_backbutton1(inputs)
	return fr_privacy_backbutton1(inputs)
});
export { privacy_backbutton1 as "privacy_backButton" }